'use client';
import { API_FAQS } from '@/constant/apiRout';
import { useFetcherCSR } from '@/lib/useFetcherCSR';

import React, { useState } from 'react';
type FAQItem = {
  id: number;
  question: string;
  answer: string;
  is_active: number; // or boolean if you convert it later
  created_at: string; // ISO date string
  updated_at: string; // ISO date string
};

const FaqAccordion = () => {
  const { data } = useFetcherCSR(API_FAQS);

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs: FAQItem[] = data?.faqs || [];
  const mid = Math.ceil(faqs.length / 2);
  const firstColumn = faqs.slice(0, mid);
  const secondColumn = faqs.slice(mid);

  return (
    <div className="faq padding-bottom of-hidden section-bg">
      <div className="container">
        <div className="faq__wrapper">
          <div className="row g-4 justify-content-between">
            <div className="col-lg-6">
              <div
                className="accordion accordion--style2"
                data-aos="fade-right"
                data-aos-duration={1000}
              >
                {firstColumn.map((item: FAQItem, index: number) => (
                  <div key={index} className="accordion__item accordion-item">
                    <div className="accordion__header accordion-header">
                      <button
                        className={`accordion-button accordion-button--style3 accordion__button ${openIndex === index ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => toggleAccordion(index)}
                        aria-expanded={openIndex === index}
                        aria-controls={`faqBody${index}`}
                      >
                        <span className="accordion__button-content">
                          {item?.question}
                        </span>
                        {/* <HugeiconsIcon icon={ArrowDown01Icon}
                          className={`accordion__arrow-icon ${openIndex === index ? 'rotate' : ''}`}
                        /> */}
                      </button>
                    </div>
                    <div
                      id={`faqBody${index}`}
                      className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`}
                    >
                      <div className="accordion__body accordion-body">
                        <p className="mb-0">{item?.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="accordion accordion--style2"
                data-aos="fade-right"
                data-aos-duration={1000}
              >
                {secondColumn?.map((item: FAQItem, index: number) => (
                  <div
                    key={index + 10}
                    className="accordion__item accordion-item"
                  >
                    <div className="accordion__header accordion-header">
                      <button
                        className={`accordion-button accordion-button--style3 accordion__button ${openIndex === index + 10 ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => toggleAccordion(index + 10)}
                        aria-expanded={openIndex === index + 10}
                        aria-controls={`faqBody${index + 10}`}
                      >
                        <span className="accordion__button-content">
                          {item.question}
                        </span>
                      </button>
                    </div>
                    <div
                      id={`faqBody${index + 10}`}
                      className={`accordion-collapse collapse ${openIndex === index + 10 ? 'show' : ''}`}
                    >
                      <div className="accordion__body accordion-body">
                        <p className="mb-0">{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqAccordion;
